import { convertSelectedFiltersToQueryFilters } from '../../../../adapters/api/queryFilters/queryFilters';
import { AsyncComponentDataStatus } from '../../state/types';
import { DailyAgendaActionFactory, DailyAgendaActions } from '../actions';
import debounce from 'lodash.debounce';
import { Filter } from '../../../../types/types';
import { initSlots } from '../../../../adapters/initWidgetData/initSlots/initSlots';
import { initAvailableDays } from '../../../../adapters/initWidgetData/initAvailableDays/initAvailableDays';
import { initBookings } from '../../../../adapters/initWidgetData/initBookings/initBookings';
import { TriggeredByOptions } from '../../../../utils/bi/consts';

export const createOnFiltersChangeAction: DailyAgendaActionFactory<
  DailyAgendaActions['onFiltersChange']
> = ({ setState, flowAPI, getState, biLogger }) => {
  const fetchData = async () =>
    Promise.all([
      initSlots(
        { flowAPI, setState, getState, biLogger },
        TriggeredByOptions.FILTER_CHANGED,
      ),
      initBookings({ flowAPI, setState, getState }),
      initAvailableDays(
        { flowAPI, setState, getState, biLogger },
        TriggeredByOptions.FILTER_CHANGED,
      ),
    ]);

  const debouncedFetchData = debounce(fetchData, 250);

  return async (newSelectedFilters: Filter[]) => {
    setState({
      selectedFilters: convertSelectedFiltersToQueryFilters(newSelectedFilters),
      slots: { status: AsyncComponentDataStatus.LOADING },
      availableDays: { status: AsyncComponentDataStatus.LOADING },
      slotsMetaData: { status: AsyncComponentDataStatus.LOADING },
      bookedSlots: { status: AsyncComponentDataStatus.LOADING },
      bookedSlotsMetaData: { status: AsyncComponentDataStatus.LOADING },
    });

    await debouncedFetchData();
  };
};
